<h1>Main stats</h1>

@if (stats.isLoading()) {
<p>Loading...</p>
}

@if (stats.error()) {
<p class="error">Error : {{ stats.error()?.message }}</p>
}

@if (stats.hasValue()) {
<div class="n-chart-flex">
    @for (c of charts; track c) {
    <div class="n-chart-item">
        <apx-chart [series]="c.series!" [chart]="c.chart!" [xaxis]="c.xaxis!" [title]="c.title!">
        </apx-chart>
    </div>
    }
</div>
}
<button matButton (click)="onRefresh()">Refresh</button>